import { MYHOUSE_MAX_COUNT } from '@Root/contants/myhouseRegister'
import { PROMOTION_PERIOD_TYPE } from '@Root/contants/myhousePromotion'

export enum MODAL_TYPE {
  NONE,
  DELETE_PHOTO,
  DELETE_MYHOUSE,
  MAX_PHOTO_COUNT,
  MAX_PHOTO_COUNT_OVERFLOW,
  MAX_PHOTO_SIZE,
  MAX_PHOTO_SIZE_OVERFLOW,
  CONTENT_REQUIRED,
  TITLE_REQUIRED,
  CATEGORY_REQUIRED,
  CANCEL_WRITING,
  CANCEL_MODIFY,
  CONTENT_OR_IMAGE_REQUIRED,
  ARTICLE_POSTED,
  ARTICLE_MODIFIED,
  DELETE_ARTICLE,
  ARTICLE_DELETED,
  MYHOUSE_REQUIRED,
  MYHOUSE_AUTHENTICATION_REQUIRED,
  RESIDENT_AUTHENTICATION_REQUIRED,
  INSURANCE_REQUIRED,
  INSURANCE_ADD_LIMITED,
  INSURANCE_DELETE_CONFIRM,
  MANAGEMENT_PHONE,
  MYHOUSE_LIMITED,
  MYHOUSE_LIMITED_NO_ROUTE,
  AUTH_MODIFY_LIMITED,
  AUTH_MODIFY_LIMITED_URL,
  AUTH_OWNER,
  AUTH_MODIFY_ADDRESS,
  DELETE_ADDRESS,
  ADDRESS_DELETED,
  CLOSE_SERVICE,
  TAX_PC_GUIDE,
  TAX_NAVERAPP_GUIDE,
  UNIT_TREND_PRICE_PC_GUIDE,
  AUTH_REALNAME_GUIDE,
  AUTH_MOBILE_GUIDE,
  ARTICLE_AUTH_REQUIRED,
  NPAY_AUTHENTICATION_SUCCESS,
  AUTH_PROGRESS,
  AUTH_MODIFY_TRADE_TYPE,
  AUTH_NOT_COMPLETED,
  UNATTACHABLE_EXTENSION,
  AUTH_MAX_PHOTO_SIZE,
  AUTH_RETRY_RESIDENT,
  AUTH_RETRY_OWNER,
  REFUSE_WRITE_REVIEW,
  AUTH_COMPLETE_OWNER,
  AUTH_COMPLETE_RESIDENT,
  /*무료보험 프로모션 추가부분 시작(7.17 이후 제거)*/
  '화재보험 무료 가입 신청 완료',
  '화재보험 무료 가입 신청 기 완료',
  '입주민 인증 신청 완료',
  '우리집 프로모션 종료 시',
  '재접수 시도시',
  '금주 접수 종료',
  '내국인만 가입 신청',
  '우리집 프로모션 신청 실패_인증실패',
  '우리집 프로모션 신청 실패_기타',
  /*무료보험 프로모션 추가부분 끝*/
  '우리집 등록 중복',
}

export enum MODAL_BUTTON_TYPE {
  NONE,
  CONFIRM,
  CANCEL_WRITING_ARTICLE,
  CANCEL_MODIFY_ARTICLE,
  MYHOUSE_REQUIRED,
  MYHOUSE_AUTHENTICATION_REQUIRED,
  DELETE,
  INSURANCE_REQUIRED_MYHOUSE_AUTH,
  CANCEL,
  MYHOUSE_LIMITED,
  MYHOUSE_LIMITED_NO_ROUTE,
  AUTH_MODIFY_LIMITED_URL,
  AUTH_OWNER,
  AUTH_MODIFY_ADDRESS,
  CLOSE_SERVICE,
  TAX_NAVERAPP_GUIDE,
  AUTH_REALNAME_GUIDE,
  CHANGE_OF_RESIDENCE,
  AUTH_RETRY_RESIDENT,
  AUTH_RETRY_OWNER,
  CLOSE,
  '우리집 바로가기',
  '우리집 등록 중복',
}

type ModalInfoReturnType = {
  vertical?: boolean
  isNewType?: boolean
  title: string
  address?: string
  desc?: string
  linkText?: string
  subDesc?: string
  myhouseNo?: string
  complexNo?: string
  phoneList?: Array<string>
  promotionPeriod?: PROMOTION_PERIOD_TYPE
  buttonType: MODAL_BUTTON_TYPE
  nclickConfirm?: string
  nclickCancel?: string
}

export const MODAL_INFO = (
  type: MODAL_TYPE,
  optionalData: {
    title: string | null
    phoneList?: Array<string> | null
    myhouseNo: string | null
    complexNo: string | null
    promotionPeriod: PROMOTION_PERIOD_TYPE | null
    nclickConfirm: string | null
    nclickCancel: string | null
    address: string
  } | null,
): ModalInfoReturnType => {
  const rtn: ModalInfoReturnType = MODAL_INFO_CONST[type]
  Object.assign(rtn, {
    title: optionalData?.title ?? rtn?.title,
    myhouseNo: optionalData?.myhouseNo ?? rtn.myhouseNo,
    complexNo: optionalData?.complexNo ?? rtn.complexNo,
    phoneList: optionalData?.phoneList ?? rtn.phoneList,
    promotionPeriod: optionalData?.promotionPeriod ?? rtn.promotionPeriod,
    nclickConfirm: optionalData?.nclickConfirm ?? rtn.nclickConfirm,
    nclickCancel: optionalData?.nclickCancel ?? rtn.nclickCancel,
    address: optionalData?.address ?? rtn.address,
  })

  return rtn
}

export const MODAL_INFO_CONST: Record<MODAL_TYPE, ModalInfoReturnType> = {
  [MODAL_TYPE.NONE]: {
    title: '',
    buttonType: MODAL_BUTTON_TYPE.NONE,
  },
  [MODAL_TYPE.DELETE_PHOTO]: {
    title: '사진을 삭제하시겠습니까?',
    buttonType: MODAL_BUTTON_TYPE.DELETE,
  },
  [MODAL_TYPE.DELETE_MYHOUSE]: {
    title: '선택한 주소를 우리집에서\n 삭제하시겠습니까?',
    buttonType: MODAL_BUTTON_TYPE.DELETE,
  },
  [MODAL_TYPE.MAX_PHOTO_COUNT_OVERFLOW]: {
    title: '첨부 사진 개수 초과',
    desc: '최대 20장까지 첨부 가능합니다.\n초과한 사진은 첨부되지 않습니다.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.MAX_PHOTO_COUNT]: {
    title: '첨부 사진 개수 초과',
    desc: '최대 20장까지 첨부 가능합니다.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.MAX_PHOTO_SIZE]: {
    title: '첨부 용량 초과',
    desc: '최대 30MB까지 첨부 가능합니다.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.MAX_PHOTO_SIZE_OVERFLOW]: {
    title: '첨부 용량 초과',
    desc: '최대 30MB까지 첨부 가능합니다.\n초과한 사진은 첨부되지 않습니다.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.CONTENT_REQUIRED]: {
    title: '내용을 입력해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.TITLE_REQUIRED]: {
    title: '제목을 입력해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.CATEGORY_REQUIRED]: {
    title: '공지 타입을 설정해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.CONTENT_OR_IMAGE_REQUIRED]: {
    title: '내용을 입력하거나 사진을 첨부해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.CANCEL_WRITING]: {
    title: '작성을 취소하시겠습니까? \n입력한 내용은 저장되지 않습니다.',
    buttonType: MODAL_BUTTON_TYPE.CANCEL_WRITING_ARTICLE,
  },
  [MODAL_TYPE.CANCEL_MODIFY]: {
    title: '수정을 취소하시겠습니까? \n입력한 내용은 저장되지 않습니다.',
    buttonType: MODAL_BUTTON_TYPE.CANCEL_MODIFY_ARTICLE,
  },
  [MODAL_TYPE.ARTICLE_POSTED]: {
    title: '게시글이 등록되었습니다.',
    buttonType: MODAL_BUTTON_TYPE.NONE,
  },
  [MODAL_TYPE.ARTICLE_MODIFIED]: {
    title: '게시글이 수정되었습니다.',
    buttonType: MODAL_BUTTON_TYPE.NONE,
  },
  [MODAL_TYPE.DELETE_ARTICLE]: {
    title: '해당 게시글을 삭제하시겠습니까?',
    buttonType: MODAL_BUTTON_TYPE.DELETE,
  },
  [MODAL_TYPE.ARTICLE_DELETED]: {
    title: '게시글이 삭제되었습니다.',
    buttonType: MODAL_BUTTON_TYPE.NONE,
  },
  [MODAL_TYPE.MYHOUSE_REQUIRED]: {
    title: '소유 또는 거주 중인 집을 우리집으로 등록해 주세요.',
    desc: '하나 이상의 우리집을 등록해야 리뷰를 확인할 수 있습니다.',
    buttonType: MODAL_BUTTON_TYPE.MYHOUSE_REQUIRED,
  },
  [MODAL_TYPE.MYHOUSE_AUTHENTICATION_REQUIRED]: {
    title: '우리집 인증 후에\n 이용할 수 있는 기능입니다.',
    desc: '인증하면 우리집에 관한 더 많은 정보를\n받아보실 수 있습니다.',
    buttonType: MODAL_BUTTON_TYPE.MYHOUSE_AUTHENTICATION_REQUIRED,
  },
  [MODAL_TYPE.RESIDENT_AUTHENTICATION_REQUIRED]: {
    title: '입주민 인증 후에\n 이용할 수 있는 기능입니다.',
    desc: '인증하면 우리집에 관한 더 많은 정보를\n받아보실 수 있습니다.',
    buttonType: MODAL_BUTTON_TYPE.MYHOUSE_AUTHENTICATION_REQUIRED,
  },
  [MODAL_TYPE.INSURANCE_REQUIRED]: {
    title: '우리집 인증 후에 보험을 등록할 수 있습니다.',
    buttonType: MODAL_BUTTON_TYPE.INSURANCE_REQUIRED_MYHOUSE_AUTH,
  },
  [MODAL_TYPE.INSURANCE_ADD_LIMITED]: {
    title: '보험을 추가할 수 없습니다.',
    desc: '보험은 최대 10개까지 등록할 수 있습니다. 새로운 보험을 추가하려면 기존의 보험을 삭제 후 등록해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.INSURANCE_DELETE_CONFIRM]: {
    title: '해당 보험 정보를 삭제하시겠습니까?',
    buttonType: MODAL_BUTTON_TYPE.DELETE,
  },
  [MODAL_TYPE.MANAGEMENT_PHONE]: {
    vertical: true,
    title: '미켈란쉐르빌\n관리사무소',
    phoneList: ['031-775-4562', '010-2775-4563'],
    buttonType: MODAL_BUTTON_TYPE.CANCEL,
  },
  [MODAL_TYPE.MYHOUSE_LIMITED]: {
    title: '우리집을 추가할 수 없습니다.',
    desc: '우리집은 최대 ' + MYHOUSE_MAX_COUNT + '개까지 등록할 수 있습니다. 새로운 집을 추가하려면 기존의 집 주소를 삭제 후 등록해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.MYHOUSE_LIMITED,
  },
  [MODAL_TYPE.MYHOUSE_LIMITED_NO_ROUTE]: {
    title: '우리집을 추가할 수 없습니다.',
    desc: '우리집은 최대 ' + MYHOUSE_MAX_COUNT + '개까지 등록할 수 있습니다. 새로운 집을 추가하려면 기존의 집 주소를 삭제 후 등록해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.MYHOUSE_LIMITED_NO_ROUTE,
  },
  [MODAL_TYPE.AUTH_OWNER]: {
    title: '집주인 인증을 하시겠습니까?',
    myhouseNo: '',
    desc: '<em style="color: #3b7cf5">본인 명의의 부동산</em>인 경우 집주인 인증이 가능합니다. 인증 완료하고 집주인 전용 서비스를 이용해 보세요!',
    buttonType: MODAL_BUTTON_TYPE.AUTH_OWNER,
  },
  [MODAL_TYPE.AUTH_MODIFY_ADDRESS]: {
    title: '주소지를 변경하시겠습니까?',
    desc: '주소지를 변경하면 <em style="color: #3b7cf5">우리집 인증이 해지</em>되며, 서비스 이용에 제한이 발생할 수 있습니다.\n(신규 인증 진행 가능)',
    buttonType: MODAL_BUTTON_TYPE.AUTH_MODIFY_ADDRESS,
  },
  [MODAL_TYPE.AUTH_MODIFY_LIMITED]: {
    title: '인증 진행 중에는 우리집 정보를 \n 수정할 수 없습니다.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.AUTH_MODIFY_LIMITED_URL]: {
    title: '인증 진행 중에는 우리집 정보를 \n 수정할 수 없습니다.',
    buttonType: MODAL_BUTTON_TYPE.AUTH_MODIFY_LIMITED_URL,
  },
  [MODAL_TYPE.DELETE_ADDRESS]: {
    title: '이 주소를 우리집에서 \n 삭제하시겠습니까?',
    buttonType: MODAL_BUTTON_TYPE.DELETE,
  },
  [MODAL_TYPE.ADDRESS_DELETED]: {
    title: '주소가 삭제되었습니다.',
    buttonType: MODAL_BUTTON_TYPE.NONE,
  },
  [MODAL_TYPE.CLOSE_SERVICE]: {
    title: '서비스를 해지하시겠습니까?',
    desc: '서비스를 해지하면 우리집 등록 시에\n입력한 정보가 모두 삭제됩니다.\n단, 작성한 공지사항과 입주민 리뷰 글은\n자동으로 삭제되지 않습니다.',
    buttonType: MODAL_BUTTON_TYPE.CLOSE_SERVICE,
  },
  [MODAL_TYPE.TAX_PC_GUIDE]: {
    title: '해당 기능은 네이버 모바일앱에서\n이용할 수 있는 서비스입니다.',
    desc: '지방세입(재산세, 주민세) 상세 정보를 확인하거나 네이버 전자문서 서비스를 이용하려면, 네이버 모바일앱을 통해\n접근해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.TAX_NAVERAPP_GUIDE]: {
    title: '세금 고지서는 네이버앱을 통해 확인할 수 있습니다.',
    desc: '네이버앱을 설치한 후 우리집으로 다시 접근해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.TAX_NAVERAPP_GUIDE,
  },
  [MODAL_TYPE.UNIT_TREND_PRICE_PC_GUIDE]: {
    title: '호별 시세는 모바일에서만 \n 확인할 수 있습니다.',
    desc: '보유하신 모바일 기기에서 네이버 앱 또는 \n 네이버 웹으로 접근해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.AUTH_MOBILE_GUIDE]: {
    title: '해당 인증 방법은 모바일에서만 \n 진행할 수 있습니다.',
    desc: '보유하신 모바일 기기에서 네이버 앱 또는 네이버 웹으로 접근해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.AUTH_REALNAME_GUIDE]: {
    title: '집주인 인증을 위해 고객님의 \n 실명 확인이 필요합니다.',
    desc: '본인 확인을 하지 않으면 인증을 완료할 수 없습니다.',
    buttonType: MODAL_BUTTON_TYPE.AUTH_REALNAME_GUIDE,
  },
  [MODAL_TYPE.ARTICLE_AUTH_REQUIRED]: {
    title: '인증이 해제되었기 때문에 \n게시글 관리에 대한 권한이 없습니다.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.NPAY_AUTHENTICATION_SUCCESS]: {
    title: '입주민 인증이 완료되었습니다.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  /*TODO: 기획확정 후 팝업문구 내용 변경필요*/
  [MODAL_TYPE.AUTH_PROGRESS]: {
    title: '인증 진행 중 입니다.\n 조금만 더 기다려 주세요.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.AUTH_MODIFY_TRADE_TYPE]: {
    title: '전/월세로 변경하시겠습니까?',
    desc: '주거형태를 전세 또는 월세로 변경하면 \n<em style="color: #3b7cf5">집주인 인증이 해지</em>되며, \n서비스 이용에 제한이 발생할 수 있습니다. \n(입주민 인증 진행 가능)',
    buttonType: MODAL_BUTTON_TYPE.CHANGE_OF_RESIDENCE,
  },
  [MODAL_TYPE.AUTH_NOT_COMPLETED]: {
    title: '우리집 인증이 완료되지 않았습니다.',
    desc: '인증 후에 이용할 수 있는 기능입니다.\n조금만 더 기다려 주세요.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.UNATTACHABLE_EXTENSION]: {
    title: '첨부할 수 없는 확장자입니다.',
    desc: '지원하지 않는 파일 형식이므로\n첨부할 수 없습니다.\n(JPG, JPEG, PNG, BMP 형식만 허용)',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.AUTH_MAX_PHOTO_SIZE]: {
    title: '첨부 용량 초과',
    desc: '최대 5MB까지 첨부 가능합니다.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.AUTH_RETRY_RESIDENT]: {
    title: '입주민 인증을 진행하시겠습니까?',
    desc: '집주인 인증을 2번 실패하여, \n더 이상 집주인 인증을 진행할 수 없습니다. \n입주민 인증을 시도해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.AUTH_RETRY_RESIDENT,
  },
  [MODAL_TYPE.AUTH_RETRY_OWNER]: {
    title: '집주인 인증을 진행하시겠습니까?',
    desc: '입주민 인증을 2번 실패하여, \n더 이상 입주민 인증을 진행할 수 없습니다. \n집주인 인증을 시도해 주세요.',
    buttonType: MODAL_BUTTON_TYPE.AUTH_RETRY_OWNER,
  },
  [MODAL_TYPE.REFUSE_WRITE_REVIEW]: {
    title: '해당 아파트 단지의\n입주민이 아니므로\n리뷰를 작성하실 수 없습니다.',
    buttonType: MODAL_BUTTON_TYPE.CONFIRM,
  },
  [MODAL_TYPE.AUTH_COMPLETE_OWNER]: {
    title: '집주인 인증이 완료되었어요.',
    isNewType: true,
    buttonType: MODAL_BUTTON_TYPE.CLOSE,
  },
  [MODAL_TYPE.AUTH_COMPLETE_RESIDENT]: {
    title: '입주민 인증이 완료되었어요.',
    isNewType: true,
    buttonType: MODAL_BUTTON_TYPE.CLOSE,
  },
  [MODAL_TYPE['화재보험 무료 가입 신청 완료']]: {
    title: '화재보험 무료 가입 신청이\n완료되었어요.',
    isNewType: true,
    linkText: '화재보험 무료 가입 혜택 알리기',
    desc: '집주인 인증 성공시 익월부터\n보험 혜택을 받을 수 있어요.\n인증이 완료되는데 영업일 기준\n1~3일이 소요됩니다.',
    buttonType: MODAL_BUTTON_TYPE.CLOSE,
  },
  [MODAL_TYPE['화재보험 무료 가입 신청 기 완료']]: {
    title: '화재보험 무료 가입 신청이\n완료되었어요.',
    isNewType: true,
    linkText: '화재보험 무료 가입 혜택 알리기',
    desc: '익월부터 보험 혜택을 받을 수 있어요.',
    buttonType: MODAL_BUTTON_TYPE.CLOSE,
  },
  [MODAL_TYPE['입주민 인증 신청 완료']]: {
    title: '입주민 인증이 신청되었어요.',
    isNewType: true,
    desc: '인증이 완료되는데 영업일 기준\n1~3일이 소요됩니다.',
    buttonType: MODAL_BUTTON_TYPE.CLOSE,
  },
  [MODAL_TYPE['우리집 프로모션 종료 시']]: {
    title: '화재보험 무료 가입\n이벤트 종료 안내',
    isNewType: true,
    desc:
      '선착순 20만명 주택화재보험\n무료 가입 이벤트가 접수 마감되었습니다.\n이후의 신청 건은 모두 반려 처리됩니다.\n많은 관심과 애정 보여주셔서 감사합니다.\n더욱 성장하는 우리집 서비스 되겠습니다.',
    buttonType: MODAL_BUTTON_TYPE.CLOSE,
  },
  [MODAL_TYPE['재접수 시도시']]: {
    title: '이미 무료 화재보험에\n가입 신청한 내역이 있어요.',
    isNewType: true,
    buttonType: MODAL_BUTTON_TYPE['우리집 바로가기'],
  },
  [MODAL_TYPE['금주 접수 종료']]: {
    title: '화재보험 무료 가입\n금주 선착순 신청 마감 안내',
    isNewType: true,
    desc: '금주 선착순 2만명 접수가 마감되었습니다.\n아쉽지만 다음주에 다시 도전해 보세요.\n다음주 일정 : {startDate} ~ {endDate}\n(시작일 0시부터 신청할 수 있어요.)',
    buttonType: MODAL_BUTTON_TYPE.CLOSE,
  },
  [MODAL_TYPE['내국인만 가입 신청']]: {
    title: '무료 화재보험은\n내국인만 가입 신청할 수 있어요.',
    isNewType: true,
    buttonType: MODAL_BUTTON_TYPE['우리집 바로가기'],
  },
  [MODAL_TYPE['우리집 프로모션 신청 실패_인증실패']]: {
    title: '우리집 인증에 반려되어 가입 신청할 수 없습니다.',
    isNewType: true,
    buttonType: MODAL_BUTTON_TYPE['우리집 바로가기'],
  },
  [MODAL_TYPE['우리집 프로모션 신청 실패_기타']]: {
    title: '무료 화재보험에 가입 신청할 수 없습니다.',
    isNewType: true,
    buttonType: MODAL_BUTTON_TYPE['우리집 바로가기'],
  },
  [MODAL_TYPE['우리집 등록 중복']]: {
    title: '이미 등록된 주소입니다',
    address: '',
    desc: '먼저 등록된 집으로\n우리집 서비스를 이용해 주세요.',
    isNewType: true,
    buttonType: MODAL_BUTTON_TYPE['우리집 등록 중복'],
  },
}

export enum MODAL_HANDLER_TYPE {
  CLOSE,
  ACTION,
}

interface ModalButton {
  className?: string
  title: string
  handlerType: MODAL_HANDLER_TYPE
}

export const MODAL_BUTTON_INFO: Record<
  MODAL_BUTTON_TYPE,
  {
    button1?: ModalButton
    button2?: ModalButton
  }
> = {
  [MODAL_BUTTON_TYPE.NONE]: {},
  [MODAL_BUTTON_TYPE.CONFIRM]: {
    button1: {
      title: '확인',
      className: 'type_confirm',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
  },
  [MODAL_BUTTON_TYPE.CANCEL]: {
    button1: {
      title: '취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
  },
  [MODAL_BUTTON_TYPE.DELETE]: {
    button1: {
      title: '취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '삭제하기',
      className: 'type_delete',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.CANCEL_WRITING_ARTICLE]: {
    button1: {
      title: '작성 취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
    button2: {
      title: '작성 계속하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
  },
  [MODAL_BUTTON_TYPE.CANCEL_MODIFY_ARTICLE]: {
    button1: {
      title: '수정 취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
    button2: {
      title: '수정 계속하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
  },
  [MODAL_BUTTON_TYPE.MYHOUSE_REQUIRED]: {
    button1: {
      title: '취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '등록하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.MYHOUSE_AUTHENTICATION_REQUIRED]: {
    button1: {
      title: '취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '인증하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.INSURANCE_REQUIRED_MYHOUSE_AUTH]: {
    button1: {
      title: '취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '우리집 인증하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.MYHOUSE_LIMITED]: {
    button1: {
      title: '닫기',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '삭제하러 가기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.MYHOUSE_LIMITED_NO_ROUTE]: {
    button1: {
      title: '확인',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
  },
  [MODAL_BUTTON_TYPE.AUTH_OWNER]: {
    button1: {
      title: '닫기',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '집주인 인증하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.AUTH_RETRY_RESIDENT]: {
    button1: {
      title: '닫기',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '입주민 인증하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.AUTH_RETRY_OWNER]: {
    button1: {
      title: '닫기',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '집주인 인증하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.AUTH_MODIFY_ADDRESS]: {
    button1: {
      title: '취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '주소 변경하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.AUTH_MODIFY_LIMITED_URL]: {
    button1: {
      title: '우리집으로 이동하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.CLOSE_SERVICE]: {
    button1: {
      title: '취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '해지하기',
      className: 'type_delete',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.TAX_NAVERAPP_GUIDE]: {
    button1: {
      title: '취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '네이버앱 설치',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.AUTH_REALNAME_GUIDE]: {
    button1: {
      title: '취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '본인 확인하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.CHANGE_OF_RESIDENCE]: {
    button1: {
      title: '취소',
      className: 'type_cancel',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '변경하기',
      className: 'type_continue',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE.CLOSE]: {
    button1: {
      title: '닫기',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
  },
  [MODAL_BUTTON_TYPE['우리집 바로가기']]: {
    button1: {
      title: '우리집 바로가기',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
  [MODAL_BUTTON_TYPE['우리집 등록 중복']]: {
    button1: {
      title: '닫기',
      handlerType: MODAL_HANDLER_TYPE.CLOSE,
    },
    button2: {
      title: '우리집 바로가기',
      className: 'type_house',
      handlerType: MODAL_HANDLER_TYPE.ACTION,
    },
  },
}
